// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "7bd3ae2d01ddd932d2da48085ca4c9f3" + ".js";
};